/**
 * Calendar route — the app root (/).
 *
 * Protected by the _app.tsx beforeLoad auth guard (T-03-07): unauthenticated
 * visitors are redirected to /login. This is the default landing page after
 * sign-in (index route of the _app layout).
 *
 * Renders CalendarPage in a full-width flex layout matching entries.tsx.
 * Page background: Slate-50 (dominant 60%) — set by the _app layout.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CalendarPage } from '@/features/calendar/CalendarPage';

function CalendarRoute() {
  return (
    <div className="flex flex-col justify-start min-h-[calc(100vh-72px)]">
      <CalendarPage />
    </div>
  );
}

export const Route = createFileRoute('/_app/')({
  component: CalendarRoute,
});
